import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Tabs, TabsItemProps } from '../../components/Tabs'
import Invitation from './invitation'
import Reward from './reward'
import Blindbox from './blindbox'
import Mynft from '../mynft'
import { useVipInfo } from '../../context/VipInfoContext'
import Vip from '../vip'
import { useSearchParams } from 'react-router-dom'
import { setReferCode } from '../../utils'
import MyIgo from './myigo'
import MemberInfo from './member-info'
import { useIsPolygon } from 'hooks/useEnvConfig'

const tabVipItems: TabsItemProps[] = [
  {
    title: 'My NFT',
    id: 'mynft',
  },
  {
    title: 'Member',
    id: 'member',
  },
]

const tabItems: TabsItemProps[] = [
  {
    title: 'My NFT',
    id: 'mynft',
  },
  {
    title: 'Account',
    id: 'account',
  },
  {
    title: 'My Mystery Box',
    id: 'blindbox',
  },
  {
    title: 'My IGO',
    id: 'myigo',
  },
]
export default function Account() {
  const { isRegistered } = useVipInfo()
  const isPolygon = useIsPolygon()

  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') || ''
  const referCode = searchParams.get('refer') || ''
  const [tabId, setTabId] = useState(
    ['blindbox', 'account', 'myigo', 'mypower', 'mycollection', 'mynft'].includes(tab) ? tab : tabItems[0].id,
  )
  const [tabVipId, setTabVipId] = useState(['member', 'mynft'].includes(tab) ? tab : tabVipItems[0].id)
  useEffect(() => {
    const refer = searchParams.get('refer')
    if (refer) {
      setReferCode(refer)
    }
  }, [searchParams])
  useEffect(() => {
    const obj = {
      tab: isRegistered ? tabId : tabVipId,
    }
    if (referCode) {
      obj['refer'] = referCode
    }
    //@ts-ignore
    setSearchParams(obj)
  }, [tabId, tabVipId, referCode, setSearchParams, isRegistered])

  return !isRegistered || isPolygon ? (
    <AccountWrapper>
      <TabsWrapper>
        <Tabs items={tabVipItems} value={tabVipId} onChange={setTabVipId} />
      </TabsWrapper>

      {tabVipId === 'member' && <Vip />}
      {tabVipId === 'mynft' && <Mynft />}
    </AccountWrapper>
  ) : (
    <AccountWrapper>
      <TabsWrapper>
        <Tabs items={tabItems} value={tabId} onChange={setTabId} />
      </TabsWrapper>
      {tabId === 'account' && <MyAccount />}
      {tabId === 'blindbox' && <Blindbox />}
      {tabId === 'myigo' && <MyIgo />}
      {tabId === 'mynft' && <Mynft />}
    </AccountWrapper>
  )
}

const AccountWrapper = styled.div`
  width: 1150px;
  margin: 46px auto 0 auto;
  position: relative;
`
const TabsWrapper = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const CardsWrapper = styled.div`
  width: 100%;

  margin-top: 44px;
  padding-bottom: 50px;
  & > div:first-child {
    height: 447px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

function MyAccount() {
  return (
    <CardsWrapper>
      <div>
        <Invitation />
        <Reward />
      </div>
      <MemberInfo />
    </CardsWrapper>
  )
}
